import { ca } from '@cian/analytics';
import { TDeviceType } from '@cian/ui-kit';

interface ITrackInformerOpenArgs {
  deviceType: TDeviceType | undefined;
  objectId: number;
}

export const trackInformerOpen = ({ deviceType, objectId }: ITrackInformerOpenArgs) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DailyrentReviews',
    action: 'click_sopr',
    label: 'moderation_info',
    page: {
      pageType: 'ReviewsDailyrent',
      siteType: deviceType,
    },
    products: [{ id: objectId, offerType: 'offer' }],
  });
};
